module.exports = __webpack_public_path__ + "img/icon-arrow-blue.66f188d8.svg";